export default "__VITE_ASSET__CAmqn__f__"